import Reports from "./pages/Reports";
import Deposit from "./pages/Deposit";
import CreateNewGroup from "./pages/Admin/CreateNewGroup";
import Dashboard from "./pages/Dashboard";
import AccountDetails from "./pages/details/admin/AccountDetails";
import GroupDetails from "./pages/details/admin/GroupDetails";
import PaymentMethodEventDetails from "./pages/details/admin/PaymentMethodEventDetails";
import PaymentHostEventDetails from "./pages/details/admin/PaymentHostEventDetails";
import PaymentBrandEventDetails from "./pages/details/admin/PaymentBrandEventDetails";
import PaymentHostDetails from "./pages/details/admin/PaymentHostDetails";
import Profile from "./pages/Profile";
import EntityDetails from "./pages/details/entity/EntityDetails";
import MerchantDetails from "./pages/details/admin/MerchantDetails";
import MerchantUserDetails from "./pages/details/admin/MerchantUserDetails";
import TerminalDetails from "./pages/details/admin/TerminalDetails";
import MismatchedDetails from "./pages/Reconciliations/MismatchedDetails";
import ReconciledDetails from "./pages/Reconciliations/ReconciledDetails";
import TransactionDetails from "./pages/Reconciliations/TransactionDetails";
import ChargebackDetails from "./pages/Reconciliations/ChargebackDetails";
import Maintenance from "./pages/Maintenance";
import PayoutDetails from "./pages/details/admin/PayoutDetails";
import SettlementDetails from "./pages/details/SettlementDetails";
import { ReportDetails } from "./pages/details/ReportDetails";
import { DepositDetails } from "./pages/details/DepositDetails";
import VirtualAccountDetails from "./pages/details/VirtualAccountDetails";
import { VAPayoutDetails } from "./pages/details/VirtualAccounPayoutDetails";
import AccountSwitchView from "./components/Admin-Account/AccountSwitchView";
import { ROLES, SCOPE_IDENTIFIERS } from "./utils/constants";
import GroupSwitchView from "./components/Admin-Group/GroupSwitchView";
import MerchantUserSwitchView from "./components/Admin-MerchantUser/MerchantUserSwitchView";
import VASwitchView from "./components/Virtual-Account/VASwitchView";
import PendingTransfer from "./components/Virtual-Account/PendingTransfer";
import CompletedTransfer from "./components/Virtual-Account/CompletedTransfer";
import MismatchedList from "./components/reconciliations/MismatchedList";
import ChargebackList from "./components/reconciliations/ChargebackList";
import ReconciledList from "./components/reconciliations/ReconciledList";
import PendingList from "./components/settlements/PendingList";
import ApprovedList from "./components/settlements/ApprovedList";
import RejectedList from "./components/settlements/RejectedList";
import PayoutSwitchView from "./components/Admin-Payout/PayoutSwitchView";
import TransactionList from "./components/reconciliations/TransactionList";
import EntitySwitchView from "./components/Business-Entity/EntitySwitchView";
import MerchantSwitchView from "./components/Admin-Merchant/MerchantSwitchView";
import TerminalSwitchView from "./components/Admin-Terminal/TerminalSwitchView";
import PaymentHostSwitchView from "./components/Admin-PaymentHost/PaymentHostSwitchView";
import AuditLogs from "./pages/Audit-logs";
import ProductUpdate from "./pages/product-update";
import DataSubmissionFile from "./pages/data-submission-file";
import PayNowDescriptor from "./pages/paynow-descriptor";
import PayoutPipelineManual from "./pages/payout-pipeline-manual";
import PayoutPipelineTracker from "./pages/payout-pipeline-tracker";
import PayoutPipelineTrackerDetails from "./pages/payout-pipeline-tracker/payout-pipeline-tracker-details";
import PayoutIngestor from "./pages/payout-ingestor";
import PayNowDescriptorV2 from "./pages/paynow-descriptor-v2";
import PayoutReconciliation from "./pages/payout-reconciliation";
import PayoutSettlement from "./pages/payout-settlement";
import UploadAcquirerFile from "./pages/upload-acquirer-file";
import MPI from "./pages/MPI";
import TestPaymentPage from "./pages/test-payment-page";
import BankAccountPage from "./pages/bank-account";
import BankAccountDetailsCard from "./pages/bank-account/details.js";
import MerchantPayoutInfo from "./pages/merchant-payout-info";
import QuickPayment from "./pages/quick-payment";
import ExchangeRatesPage from "./pages/finance-enhancement/exchange-rates";
import MerchantPayoutDetailsCard from "./pages/merchant-payout-info/detail.js";
import AcquirerFiles from "./pages/finance-enhancement/acquirer-files";
import BankStatements from "./pages/finance-enhancement/bank-statements";
import PayNowDuplicate from "./pages/finance-enhancement/paynow-duplicate";
import Incoming from "./pages/finance-enhancement/incoming";
import Outgoing from "./pages/finance-enhancement/outgoing";
import Pending from "./pages/finance-enhancement/pending";
import Adjustment from "./pages/finance-enhancement/adjustment";
import ExceptionHandlingPage from "./pages/finance-enhancement/exception-handling";
import Insights from "./pages/finance-enhancement/insights";
import MerchantReports from "./pages/finance-enhancement/merchant-reports";
import MASReports from "./pages/finance-enhancement/mas-reports";
import MonthlyReports from "./pages/finance-enhancement/monthly-reports";
import OnboardingPage from "./components/Onboarding";
import CreateNewOnboarding from "./components/Onboarding/CreateNewOnboarding";
import DownloadFromS3 from "./components/DownloadFromS3";
import NoPayoutDayPage from "./pages/no-payout-day";
import EditOnboardingApplication from "./components/Onboarding/EditOnboardingApplication";

const routes = [
  {
    path: "/",
    name: "maintenance",
    component: Maintenance,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },

  // Reconciliations
  {
    path: "/reconcile/mismatched",
    name: "Mismatched",
    scope: SCOPE_IDENTIFIERS.RECON_SETTLEMENT,
    component: MismatchedList,
  },
  {
    path: "/reconcile/chargeback",
    name: "Chargeback",
    scope: SCOPE_IDENTIFIERS.RECON_SETTLEMENT,
    component: ChargebackList
  },
  {
    path: "/reconcile/reconciled",
    name: "Reconciled",
    scope: SCOPE_IDENTIFIERS.RECON_SETTLEMENT,
    component: ReconciledList
  },

  {
    path: "/admin/account",
    name: "Admin User",
    scope: SCOPE_IDENTIFIERS.ACCOUNT,
    component: AccountSwitchView,
  },
  {
    path: "/admin/roles-management",
    name: "Admin Role",
    scope: SCOPE_IDENTIFIERS.GROUP,
    component: GroupSwitchView,
  },
  {
    path: "/admin/merchant-user",
    name: "Merchant User",
    scope: SCOPE_IDENTIFIERS.MERCHANT_USER,
    component: MerchantUserSwitchView,
  },

  // Settlement
  {
    path: "/settlements/pending",
    name: "Settlement Pending",
    scope: SCOPE_IDENTIFIERS.RECON_SETTLEMENT,
    component: PendingList,
  },
  {
    path: "/settlements/approved",
    name: "Settlement Approved",
    scope: SCOPE_IDENTIFIERS.RECON_SETTLEMENT,
    component: ApprovedList,
  },
  {
    path: "/settlements/rejected",
    name: "Settlement Approved",
    scope: SCOPE_IDENTIFIERS.RECON_SETTLEMENT,
    component: RejectedList,
  },

  // Report
  {
    path: "/report/reports",
    name: "Reports",
    scope: SCOPE_IDENTIFIERS.REPORT,
    component: Reports,
  },
  {
    path: "/report/deposit",
    name: "Deposit",
    scope: SCOPE_IDENTIFIERS.SECURITY_DEPOSIT,
    component: Deposit,
  },
  {
    path: "/report/merchant-payout",
    name: "Merchant Payout",
    scope: SCOPE_IDENTIFIERS.MERCHANT_PAYOUT_INFO,
    component: PayoutSwitchView,
  },

  {
    path: "/account-details/:id",
    name: "Account Details",
    scope: SCOPE_IDENTIFIERS.ACCOUNT,
    component: AccountDetails,
  },
  {
    path: "/merchant-user-details/:id",
    name: "Merchant User Details",
    scope: SCOPE_IDENTIFIERS.MERCHANT_USER,
    component: MerchantUserDetails,
  },
  {
    path: "/group-details/:id",
    name: "Group Details",
    scope: SCOPE_IDENTIFIERS.GROUP,
    component: GroupDetails,
  },
  {
    path: "/admin_group/create",
    name: "Create New Group",
    scope: SCOPE_IDENTIFIERS.GROUP,
    component: CreateNewGroup,
  },
  {
    path: "/entity-details/:id",
    name: "Business Entity Details",
    scope: SCOPE_IDENTIFIERS.BUSINESS_ENTITY,
    component: EntityDetails,
  },
  {
    path: "/terminal-details/:id",
    name: "Terminal Details",
    scope: SCOPE_IDENTIFIERS.TERMINAL,
    component: TerminalDetails,
  },
  {
    path: "/payment-host-details/:id",
    name: "Payment Host Details",
    scope: SCOPE_IDENTIFIERS.PAYMENT_HOST,
    component: PaymentHostDetails,
  },
  {
    path: "/merchant-details/:id",
    name: "Merchant Details",
    scope: SCOPE_IDENTIFIERS.MERCHANT,
    component: MerchantDetails,
  },
  {
    path: "/details/mismatched/:id",
    name: "Mismatched Details",
    scope: SCOPE_IDENTIFIERS.RECON_SETTLEMENT,
    component: MismatchedDetails,
  },
  {
    path: "/details/reconciled/:id",
    name: "Reconciled Details",
    scope: SCOPE_IDENTIFIERS.RECON_SETTLEMENT,
    component: ReconciledDetails,
  },
  {
    path: "/details/chargeback/:id",
    name: "Chargeback Details",
    scope: SCOPE_IDENTIFIERS.RECON_SETTLEMENT,
    component: ChargebackDetails,
  },

  // Transactions
  {
    path: "/transactions",
    name: "Transactions",
    scope: SCOPE_IDENTIFIERS.TRANSACTION,
    component: TransactionList,
  },
  {
    path: "/details/Transaction/:id",
    name: "Transaction Details",
    scope: SCOPE_IDENTIFIERS.TRANSACTION,
    component: TransactionDetails,
  },

  // Operations
  {
    path: "/operations/onboarding",
    name: "Onboarding",
    scope: SCOPE_IDENTIFIERS.ONBOARDING,
    component: OnboardingPage,
  },
  {
    path: "/operations/onboarding/create",
    name: "Create New Onboarding",
    scope: SCOPE_IDENTIFIERS.ONBOARDING,
    component: CreateNewOnboarding,
  },
  {
    path: "/operations/onboarding/edit/:id",
    name: "Edit Onboarding",
    scope: SCOPE_IDENTIFIERS.ONBOARDING,
    component: EditOnboardingApplication,
  },
  {
    path: "/operations/business-entity",
    name: "Business Entity",
    scope: SCOPE_IDENTIFIERS.BUSINESS_ENTITY,
    component: EntitySwitchView,
  },
  {
    path: "/operations/bank-account",
    name: "Bank Account",
    scope: SCOPE_IDENTIFIERS.BANK_ACCOUNT,
    component: BankAccountPage,
  },
  {
    path: "/operations/bank-account/details/:id",
    name: "Bank Account",
    scope: SCOPE_IDENTIFIERS.BANK_ACCOUNT,
    component: BankAccountDetailsCard,
  },
  {
    path: "/operations/merchant",
    name: "Merchant",
    scope: SCOPE_IDENTIFIERS.MERCHANT,
    component: MerchantSwitchView,
  },
  {
    path: "/operations/terminal",
    name: "Terminal",
    scope: SCOPE_IDENTIFIERS.TERMINAL,
    component: TerminalSwitchView,
  },
  {
    path: "/operations/mpi",
    name: "MPI",
    component: MPI,
    scope: SCOPE_IDENTIFIERS.MPI,
  },
  {
    path: "/operations/payment-host",
    name: "Payment Host",
    scope: SCOPE_IDENTIFIERS.PAYMENT_HOST,
    component: PaymentHostSwitchView,
  },
  {
    path: "/operations/payment-brand",
    name: "Payment Brand",
    scope: SCOPE_IDENTIFIERS.PAYMENT_BRAND,
    component: PaymentHostSwitchView,
  },
  {
    path: "/operations/payment-method",
    name: "Payment Method",
    scope: SCOPE_IDENTIFIERS.PAYMENT_METHOD,
    component: PaymentHostSwitchView,
  },
  {
    path: "/operations/quick-payment",
    name: "Quick Payment",
    scope: SCOPE_IDENTIFIERS.QUICK_PAYMENT,
    component: QuickPayment,
  },
  {
    path: "/operations/product-update",
    name: "ProductUpdate",
    component: ProductUpdate,
    scope: SCOPE_IDENTIFIERS.NOTIFICATIONS,
  },
  {
    path: "/operations/test-payment-page",
    name: "TestPaymentPage",
    component: TestPaymentPage,
  },
  {
    path: "/operations/data-file-generation",
    name: "Data File Generation",
    component: DataSubmissionFile,
    scope: SCOPE_IDENTIFIERS.TRANSACTION,
  },
  {
    path: "/operations/no-payout-day",
    name: "No Payout Day",
    component: NoPayoutDayPage,
    scope: SCOPE_IDENTIFIERS.NO_PAYOUT_DAY,
    role: ROLES.VIEW,
  },
  //   {
  //   path: "/operations/paynow-descriptor",
  //   name: "PayNow Descriptor",
  //   component: PayNowDescriptor,
  // },
  // {
  //   path: "/operations/paynow-descriptor",
  //   name: "PayNow Descriptor",
  //   component: PayNowDescriptorV2,
  //   scope: SCOPE_IDENTIFIERS.PAYNOW_DESCRIPTOR,
  // },
  {
    path: "/operations/payout-pipeline-manual",
    name: "Payout pipeline manual",
    component: PayoutPipelineManual,
    scope: SCOPE_IDENTIFIERS.PAYOUT_UPLOAD_FILE,
    role: ROLES.UPLOAD_FILE,
  },
  // {
  //   path: "/operations/upload-acquirer-file",
  //   name: "Import Data",
  //   component: UploadAcquirerFile,
  //   scope: SCOPE_IDENTIFIERS.PAYOUT_UPLOAD_FILE,
  //   role: ROLES.UPLOAD_FILE,
  // },
  {
    path: "/operations/download-from-s3",
    name: "Download from S3",
    // scope: SCOPE_IDENTIFIERS.ONBOARDING,
    component: DownloadFromS3,
  },
  {
    path: "/finance/acquirer-files",
    name: "Acquirer Files",
    component: AcquirerFiles,
    scope: SCOPE_IDENTIFIERS.ACQUIRER_FILE,
    role: ROLES.VIEW,
  },
  {
    path: "/finance/bank-statements",
    name: "Bank Statements",
    component: BankStatements,
    scope: SCOPE_IDENTIFIERS.BANK_STATEMENT,
    role: ROLES.VIEW,
  },
  // {
  //   path: "/finance/paynow-duplicate",
  //   name: "PayNow Duplicate",
  //   component: PayNowDuplicate,
  //   scope: SCOPE_IDENTIFIERS.PAYNOW_DUPLICATE,
  //   role: ROLES.VIEW,
  // },
  {
    path: "/finance/incoming",
    name: "Incoming",
    component: Incoming,
  },
  {
    path: "/finance/outgoing",
    name: "Outgoing",
    component: Outgoing,
  },
  {
    path: "/finance/pending",
    name: "Pending",
    component: Pending,
  },
  {
    path: "/finance/adjustment",
    name: "Adjustment",
    component: Adjustment,
    scope: SCOPE_IDENTIFIERS.ADJUSTMENT,
    role: ROLES.VIEW,
  },
  {
    path: "/finance/exception-handling",
    name: "Exception Handling",
    component: ExceptionHandlingPage,
    scope: SCOPE_IDENTIFIERS.EXCEPTION_HANDLING,
    role: ROLES.VIEW,
  },
  {
    path: "/finance/merchant-reports",
    name: "Merchant Reports",
    component: MerchantReports,
  },
  {
    path: "/finance/mas-reports",
    name: "MAS Reports",
    component: MASReports,
  },
  {
    path: "/finance/monthly-reports",
    name: "Monthly Reports",
    component: MonthlyReports,
  },
  {
    path: "/finance/insights",
    name: "Insights",
    component: Insights,
  },
  {
    path: "/finance/exchange-rates",
    name: "Exchange Rates",
    component: ExchangeRatesPage,
    scope: SCOPE_IDENTIFIERS.EXCHANGE_RATE,
    role: ROLES.VIEW,
  },
  // {
  //   path: "/operations/payout-pipeline-tracker",
  //   name: "Payout pipeline tracker",
  //   component: PayoutPipelineTracker,
  // },
  // {
  //   path: "/payout-pipeline-tracker-details/:id",
  //   name: "Payout pipeline tracker details",
  //   component: PayoutPipelineTrackerDetails,
  // },
  {
    path: "/operations/payout-ingestor",
    name: "Payout ingestor",
    component: PayoutIngestor,
    scope: SCOPE_IDENTIFIERS.PAYOUT_VIEW_DATA,
  },
  {
    path: "/operations/payout-reconciliation",
    name: "Payout reconciliation",
    component: PayoutReconciliation,
    scope: SCOPE_IDENTIFIERS.PAYOUT_VIEW_DATA,
  },
  {
    path: "/operations/payout-settlement",
    name: "Payout settlement",
    component: PayoutSettlement,
    scope: SCOPE_IDENTIFIERS.PAYOUT_VIEW_DATA,
  },
  {
    path: "/operations/merchant-payout-info",
    name: "Merchant Payout Info",
    component: MerchantPayoutInfo,
    scope: SCOPE_IDENTIFIERS.MERCHANT_PAYOUT_INFO,
  },
  {
    path: "/operations/business-entity/merchant-payout/:merchantId",
    name: "Merchant Payout Details",
    scope: SCOPE_IDENTIFIERS.MERCHANT_PAYOUT_INFO,
    component: MerchantPayoutDetailsCard,
  },
  // {
  //   path: "/operations/merchant-report",
  //   name: "Merchant Report",
  //   component: MerchantReport,
  // },
  {
    path: "/details/deposit/:id/:currency",
    name: "Deposit Details",
    scope: SCOPE_IDENTIFIERS.SECURITY_DEPOSIT,
    component: DepositDetails,
  },
  {
    path: "/details/payment-method-history/:id",
    name: "Method History",
    scope: SCOPE_IDENTIFIERS.PAYMENT_METHOD,
    component: PaymentMethodEventDetails,
  },
  {
    path: "/details/payment-brand-history/:id",
    name: "Brand History",
    scope: SCOPE_IDENTIFIERS.PAYMENT_BRAND,
    component: PaymentBrandEventDetails,
  },
  {
    path: "/details/payment-host-history/:id",
    name: "Host History",
    scope: SCOPE_IDENTIFIERS.PAYMENT_HOST,
    component: PaymentHostEventDetails,
  },
  {
    path: "/details/payout/:id",
    name: "Payout Details",
    scope: SCOPE_IDENTIFIERS.MERCHANT_PAYOUT_INFO,
    component: PayoutDetails,
  },
  {
    path: "/details/settlements/:id",
    name: "Settlement Details",
    scope: SCOPE_IDENTIFIERS.RECON_SETTLEMENT,
    component: SettlementDetails,
  },
  {
    path: "/details/reports/:id",
    name: "Report Details",
    scope: SCOPE_IDENTIFIERS.REPORT,
    component: ReportDetails,
  },

  // Virtual Account
  // {
  //   path: "/virtual-account/accounts",
  //   name: "Virtual Account",
  //   scope: SCOPE_IDENTIFIERS.BUSINESS_ENTITY,
  //   component: VASwitchView,
  // },
  // {
  //   path: "/virtual-account/pending-transfer",
  //   name: "Virtual Account",
  //   scope: SCOPE_IDENTIFIERS.BUSINESS_ENTITY,
  //   component: PendingTransfer,
  // },
  // {
  //   path: "/virtual-account/completed-transfer",
  //   name: "Virtual Account",
  //   scope: SCOPE_IDENTIFIERS.BUSINESS_ENTITY,
  //   component: CompletedTransfer,
  // },
  // {
  //   path: "/details/virtual-account/:id",
  //   name: "Virtual Account",
  //   scope: SCOPE_IDENTIFIERS.BUSINESS_ENTITY,
  //   component: VirtualAccountDetails,
  // },
  // {
  //   path: "/details/transactions-payout/:id",
  //   name: "Virtual Account",
  //   scope: SCOPE_IDENTIFIERS.BUSINESS_ENTITY,
  //   component: VAPayoutDetails,
  // },
  {
    path: "/audit-logs",
    name: "Audit Logs",
    component: AuditLogs,
    scope: SCOPE_IDENTIFIERS.AUDIT_LOGS,
  },
];

export default routes;
